import { normalizeFieldKey } from './fieldKey'
import { RELATION_VALUE } from './relationValue'

// `<field>.<relation field key>` (`client.contact`) points at a relation value of a field that has relation_fields: described as a
// 'relation_value' (see relationValue.js). Only when the field really has that relation field — other dotted keys (`status.name`,
// the document view's `relation_data.title`) stay as they are.
const getRelationValueType = (keyProps, fields) => {
   if (typeof keyProps !== 'string' || keyProps.indexOf('.') < 1) return {}

   const dot = keyProps.indexOf('.')
   const base = normalizeFieldKey(keyProps.slice(0, dot))
   const relationKey = keyProps.slice(dot + 1)
   const field = fields.find(f => normalizeFieldKey(f.key) == base)
   const relationField = (field?.relation_fields || []).find(r => normalizeFieldKey(r.key) == normalizeFieldKey(relationKey))
   if (!relationField) return {}

   return { field_type: RELATION_VALUE, relation_of: base, relation_key: relationField.key, relation_field: relationField }
}

function addFieldType(obj, fields = []) {
   const getFieldType = (keyProps) => {
      if (fields.length == 0) return ''

      // a view may write a field's key the way the scheme does ("other-contacts"), while the records are keyed with underscores
      // ("other_contacts"): the key the cell reads is the records' one
      const normalized = normalizeFieldKey(keyProps)
      const fieldFilter = [...fields].filter(f => normalizeFieldKey(f.key) == normalized) || []
      if (fieldFilter.length > 0) {
         const {key, ...restField} = fieldFilter[0]
         return normalized !== keyProps ? { ...restField, key: normalized } : restField
      }

      return getRelationValueType(keyProps, fields)
   }

   /**
    * Recursive function to add the field_type key without overwriting existing values
    */
   function traverse(o) {
      const keys = Object.keys(o);
      keys.forEach((key, index) => {
         if (Array.isArray(o[key]) && o[key].length > 0) {
            // let newArray = [...o[key]].map(item => ({ ...item, ...getFieldType(item.key) }))
            // o[key] = newArray

            o[key] = o[key].map(item => {
               const newFieldData = getFieldType(item.key);
               return {
                  ...item,
                  ...Object.fromEntries(
                     Object.entries(newFieldData).filter(([k]) => !(k in item) || k === 'key') // Only add missing properties (and the records' key)
                  )
               }
            })
         } else if (typeof o[key] == 'object' && Object.keys(o[key]).length > 0) {
            // if (Object.keys(o[key]).some(s => s == 'key')) {
            //    const newObj = {...o[key], ...getFieldType(o[key].key)}
            //    o[key] = newObj
            // } else {
            //    traverse(o[key]);
            // }

            if (o[key].key) {
               const newFieldData = getFieldType(o[key].key);
               o[key] = {
                  ...o[key],
                  ...Object.fromEntries(
                     Object.entries(newFieldData).filter(([k]) => !(k in o[key]) || k === 'key') // Only add missing properties (and the records' key)
                  )
               };
            } else {
               traverse(o[key]);
            }
         }
      });
   }

   // Start the traversal with the initial object
   traverse(obj);
   return obj;
}

export default addFieldType